// extracted by mini-css-extract-plugin
module.exports = {"sharePanel":"sharePanel___2MnGj","shareButton":"shareButton___et5bl"};